<!-- 日志管理 -->
<template>
    <div class="container containerBox">
        <div class="handleForm">
            <el-form
                ref="form"
                :inline="true"
                :model="form"
                label-width="80px"
                >
            <el-form-item label="查询时间">
                <el-date-picker
                v-model="form.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
				value-format="yyyy-MM-dd"
				@change="choseTime"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click="handleSearch"
                    >查询</el-button>
                </el-form-item>
                <br>
                <!-- <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-upload"
                        @click="handleExport"
                    >导出</el-button>
                </el-form-item> -->
            </el-form>
        </div>
        <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :height="maxHeight"
            stripe
            pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="page_num"
            :total="total"
            :page-size="page_sum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </lb-table>
    </div>
</template>

<script>
import Service from '@/api/Service'
import LbTable from '@/components/lb-table/lb-table'
import { getMaxHeigth, FormatDate, FormatPrevDate} from '@/utils/utils'

const nowDay = FormatDate("yyyy-MM-dd HH:mm:ss");
const prevDay = FormatPrevDate("yyyy-MM-dd HH:mm:ss");

export default {
    name: "logmanage",
    data() {
        return {
            form: {
				time: [],
				start_time: prevDay,
				end_time: nowDay,

			},

            tableData: {
                column: [
                    {
                        type: 'index',
                        align: 'center'
                    },
                    {
                        type: 'expand',
                        render: (h, props) => {
                            return  (
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item label="操作参数">
                                        <span>{ props.row.operate_data }</span>
                                    </el-form-item>
                                </el-form>
                            )
                        }
                    },
                    {
                        prop: 'that_time_user_name',
                        label: '姓名',
                    },
                    {
                        prop: 'user_name',
                        label: '用户姓名',
                    },
                    {
                        prop: 'module_key',
                        label: '操作模块',
                    },
                    {
                        prop: 'description',
                        label: '操作描述'
                    },
                    {
                        prop: 'create_date',
                        label: '时间'
                    },
                ],
                data: []
            },
            loading: false,
            maxHeight: 500,
            total: 0,
			page_num: 1,
			page_sum: 10,
            
        };
		
    },
    components: { LbTable },
    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
			
			let params = {}
			
			params.start_time = this.form.start_time
			params.end_time = this.form.end_time
			params.page_num = this.page_num
			params.page_sum = this.page_sum
			
   //          let { page_num, page_sum } = this;
			
   //          let params = Object.assign({ page_num, page_sum }, this.form)
            this.loading = true;
            let res = await Service.getLog(params);
            this.loading = false;
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.tableData.data = list;
                this.total = res.total;
            }
        },
		choseTime(val){
			this.form.start_time = val[0]
			this.form.end_time = val[1]
		},
        //   查询
        handleSearch() {
            this.getData();
        },
        //   导出
        handleExport() {},
        //   获取数据
        handleSizeChange (val) {
            this.page_num = 1
            this.page_sum = val
            this.getData()
        },
        handleCurrentChange (val) {
            if(isNaN(val)) return
            if(val === null) return
            this.page_num = val
            this.getData()
        },
    }
};
</script>
<style lang='css' scoped>
</style>